// 有可能加密，也可能不加密，所以就在这里做一下处理，改起来方便
export default require("./requestEnc").default;
// export default require("./request").default;